import { render, staticRenderFns } from "./FontTest.vue?vue&type=template&id=fca7a0d2&scoped=true"
import script from "./FontTest.vue?vue&type=script&lang=js"
export * from "./FontTest.vue?vue&type=script&lang=js"
import style0 from "./FontTest.vue?vue&type=style&index=0&id=fca7a0d2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca7a0d2",
  null
  
)

export default component.exports